let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6JkJq")).then(() => parcelRequire('3sFE0'));